import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const exportJsonSuccessful = () => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:jsonsuccessful`, 
        category: settings.categoryName 
    });
};

export default exportJsonSuccessful;